const MESES_USER_PASS_CADUC = [
  {
    id: 0,
    name: 'Nunca'
  },
  {
    id: 6,
    name: '6 meses'
  },
  {
    id: 12,
    name: '12 meses'
  }
]

export {
  MESES_USER_PASS_CADUC
}
